import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table } from "reactstrap";
import AdminPageShell, { AdminSurface } from "../../../components/Admin/AdminPageShell";
import { getApiUrl, getMediaUrl } from "../../../utils/site";

const RequestList = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updateId, setUpdateId] = useState(null);
  const [updateStatus, setUpdateStatus] = useState("");
  const [updateNotes, setUpdateNotes] = useState("");

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(getApiUrl("/api/design-requests"), {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRequests(res.data || []);
      } catch (err) {
        setError("Failed to fetch requests");
      } finally {
        setLoading(false);
      }
    };
    fetchRequests();
  }, []);

  const handleUpdate = async (id) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(
        getApiUrl(`/api/design-requests/${id}`),
        { status: updateStatus, notes: updateNotes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRequests(
        requests.map((r) => (r.id === id ? { ...r, status: updateStatus, notes: updateNotes } : r))
      );
      setUpdateId(null);
    } catch (err) {
      alert("Failed to update request");
    }
  };

  return (
    <AdminPageShell
      eyebrow="Custom design enquiries"
      title="Design Request"
      description="Review incoming customer design requests, attached references, and progress notes in one place."
    >
      <AdminSurface title="Request pipeline" subtitle={`${requests.length} customer requests`}>
        {error ? <p className="roha-admin-muted">{error}</p> : null}
        <div className="roha-admin-table-wrap">
          <Table responsive className="roha-admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Customer</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Design</th>
                <th>Image</th>
                <th>Status</th>
                <th>Notes</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="9" className="roha-admin-empty">
                    Loading request pipeline...
                  </td>
                </tr>
              ) : requests.length ? (
                requests.map((req) => (
                  <tr key={req.id}>
                    <td data-label="ID">{req.id}</td>
                    <td data-label="Customer">{req.customer_name}</td>
                    <td data-label="Email">{req.customer_email}</td>
                    <td data-label="Phone">{req.customer_phone}</td>
                    <td data-label="Design">{req.design_name || req.design_id}</td>
                    <td data-label="Image">
                      {req.design_image_url ? (
                        <img src={getMediaUrl(req.design_image_url)} alt="" className="roha-admin-image-thumb" />
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td data-label="Status">
                      {updateId === req.id ? (
                        <select
                          value={updateStatus}
                          onChange={(e) => setUpdateStatus(e.target.value)}
                          className="form-select"
                        >
                          <option value="new">New</option>
                          <option value="contacted">Contacted</option>
                          <option value="quoted">Quoted</option>
                          <option value="ordered">Ordered</option>
                          <option value="closed">Closed</option>
                        </select>
                      ) : (
                        <span className="roha-admin-pill">{req.status}</span>
                      )}
                    </td>
                    <td data-label="Notes">
                      {updateId === req.id ? (
                        <input
                          value={updateNotes}
                          onChange={(e) => setUpdateNotes(e.target.value)}
                          className="form-control"
                        />
                      ) : (
                        req.notes || "-"
                      )}
                    </td>
                    <td data-label="Actions">
                      {updateId === req.id ? (
                        <div className="roha-admin-toolbar">
                          <button className="btn btn-success btn-sm" onClick={() => handleUpdate(req.id)}>
                            Save
                          </button>
                          <button className="btn btn-secondary btn-sm" onClick={() => setUpdateId(null)}>
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <button
                          className="btn btn-info btn-sm"
                          onClick={() => {
                            setUpdateId(req.id);
                            setUpdateStatus(req.status);
                            setUpdateNotes(req.notes || "");
                          }}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="roha-admin-empty">
                    No customer design requests found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </AdminSurface>
    </AdminPageShell>
  );
};

export default RequestList;
